export const BASE_URL = "https://palmnest-backend-i9mj.vercel.app";